"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceOperationalStatus = void 0;
var ServiceOperationalStatus;
(function (ServiceOperationalStatus) {
    ServiceOperationalStatus["OPERATIONAL"] = "operational";
    ServiceOperationalStatus["DEGRADED"] = "degraded";
    ServiceOperationalStatus["OUTAGE"] = "outage";
})(ServiceOperationalStatus || (exports.ServiceOperationalStatus = ServiceOperationalStatus = {}));
